import { asyncAction } from 'lib/actionCreators'
import { createRoutine, promisifyRoutine } from 'redux-saga-routines'

export const employeeInfo = asyncAction('candidate/EMPLOYEE_INFO')
export const addEmployeeInfo = createRoutine('candidate/ADD_EMPLOYEE_INFO')
export const addEmployeeInfoPromiseCreator = promisifyRoutine(addEmployeeInfo)
